import Spinner from "../../../controls/Spinner";
import { IconButton } from "../../../controls/TooltipControls";
import { ComponentEx } from "../../../controls/ComponentEx";
import * as React from "react";
/**
 * Endorse Button
 *
 * @class EndorseModButton
 */
class EndorseModButton extends ComponentEx {
    render() {
        const { endorsedStatus, modId, t } = this.props;
        if (endorsedStatus === "pending") {
            return (React.createElement("div", { style: { textAlign: "center" } },
                React.createElement(Spinner, null)));
        }
        const { icon, tooltip } = {
            undecided: { icon: "endorse-maybe", tooltip: t("Undecided") },
            abstained: { icon: "endorse-maybe", tooltip: t("Abstained") },
            endorsed: { icon: "endorse-yes", tooltip: t("Endorsed") },
            disabled: {
                icon: "endorse-disabled",
                tooltip: t("Endorsement disabled by author"),
            },
            blocked: {
                icon: "endorse-disabled",
                tooltip: t("You have been blocked by the curator."),
            },
        }[endorsedStatus.toLowerCase()] || {
            icon: "like-maybe",
            tooltip: t("Undecided"),
        };
        return (React.createElement("div", { style: { textAlign: "center" } },
            React.createElement(IconButton, { className: "btn-embed", id: modId, tooltip: tooltip, icon: icon, onClick: this.endorseMod, disabled: endorsedStatus === "Disabled", stroke: true })));
    }
    endorseMod = () => {
        const { endorsedStatus, gameId, modId, onEndorseMod } = this.props;
        onEndorseMod(gameId, modId, endorsedStatus);
    };
}
export default EndorseModButton;
